(() => {
  const titleSelector = ".product-card [ref='productTitleLink'] .text-block, .resource-card[data-resource-type='product'] .resource-card__title, .mikan-offer h3";
  const gridSelector = '.product-grid, .mikan-featured-grid, .mikan-power-grid, .mikan-offers__grid, .resource-list--grid, .resource-list__carousel';
  const observed = new Set();
  const widths = new WeakMap();
  const heights = new WeakMap();
  let frame = 0;

  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      alignRows();
    });
  };

  const resizeObserver = new ResizeObserver(entries => {
    for (const entry of entries) {
      const width = entry.contentRect.width;
      const height = entry.contentRect.height;
      if (widths.get(entry.target) !== width || heights.get(entry.target) !== height) {
        widths.set(entry.target, width);
        heights.set(entry.target, height);
        schedule();
      }
    }
  });

  function alignRows() {
    const titles = [...document.querySelectorAll(titleSelector)].filter(title => title.closest('#MainContent') && title.closest(gridSelector));
    const current = new Set(titles);
    for (const title of observed) {
      if (!current.has(title)) {
        resizeObserver.unobserve(title);
        observed.delete(title);
      }
    }
    for (const title of titles) {
      title.style.removeProperty('--mikan-title-row-height');
      title.style.removeProperty('--mikan-title-row-offset');
      title.style.removeProperty('--mikan-model-row-gap');
      if (!observed.has(title)) {
        observed.add(title);
        resizeObserver.observe(title);
      }
      for (const model of title.querySelectorAll('mikan-model-code')) model.fit?.();
    }

    const grids = new Map();
    for (const title of titles) {
      const box = title.getBoundingClientRect();
      if (!box.width || !box.height) continue;
      const grid = title.closest(gridSelector);
      const card = title.closest('.mikan-featured-card, .mikan-offer, .product-card') || title.closest('.resource-card');
      if (!card) continue;
      const top = card.getBoundingClientRect().top;
      if (!grids.has(grid)) grids.set(grid, []);
      const rows = grids.get(grid);
      let row = rows.find(candidate => Math.abs(candidate.top - top) < 2);
      if (!row) {
        row = { top, offset: 0, height: 0, modelOffset: 0, titles: [] };
        rows.push(row);
      }
      const offset = box.top - top;
      row.offset = Math.max(row.offset, offset);
      const model = title.querySelector('.mikan-card-model');
      const modelOffset = model ? model.getBoundingClientRect().top - box.top : null;
      if (modelOffset !== null) row.modelOffset = Math.max(row.modelOffset, modelOffset);
      row.titles.push({ title, offset, height: box.height, modelOffset });
    }
    for (const rows of grids.values()) {
      for (const row of rows) {
        if (row.titles.length < 2) continue;
        for (const item of row.titles) {
          item.modelGap = item.modelOffset === null ? 0 : Math.max(0, row.modelOffset - item.modelOffset);
          row.height = Math.max(row.height, item.height + item.modelGap);
        }
        for (const { title, offset, modelGap } of row.titles) {
          const spacing = title.closest('.product-card') ? Math.max(0, row.offset - offset) : 0;
          title.style.setProperty('--mikan-model-row-gap', modelGap + 'px');
          title.style.setProperty('--mikan-title-row-offset', Math.ceil(spacing) + 'px');
          title.style.setProperty('--mikan-title-row-height', Math.ceil(row.height + spacing) + 'px');
        }
      }
    }
  }

  const mutations = new MutationObserver(records => {
    if (records.some(record => {
      const target = record.target instanceof Element ? record.target : record.target.parentElement;
      if (target?.closest(gridSelector)) return true;
      return [...record.addedNodes, ...record.removedNodes].some(node =>
        node instanceof Element && (node.matches(gridSelector) || node.querySelector(gridSelector))
      );
    })) schedule();
  });

  mutations.observe(document.body, { childList: true, subtree: true, characterData: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('scrollend', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('load', event => {
    if (event.target instanceof HTMLImageElement && event.target.closest(gridSelector)) schedule();
  }, true);
  document.fonts.ready.then(schedule);
  document.fonts.addEventListener('loadingdone', schedule);
  schedule();
})();

